import { createRoot } from 'react-dom/client';

import { AccountApplication } from './app/AccountApplication';
import { loadAccountAuthConfig } from './app/config';
import { createAccountAuthRuntime } from './features/auth/runtime.js';
import { I18nProvider } from './i18n/runtime';
import './styles/auth.css';
import './styles/platform.css';
import './styles/library.css';
import './styles/neo.css';
import './styles/admin.css';
import './styles/meetings.css';
import './styles/recordings.css';
import './styles/recording-library.css';
import './styles/service-pages.css';
import './styles/vue-source.css';
import './styles/vue-parity.css';

const config = loadAccountAuthConfig();
const runtime = createAccountAuthRuntime({
  baseUrl: config.apiBaseUrl,
  handoffUrl: config.handoffUrl,
  location: window.location,
});
const root = document.getElementById('root');

if (!root) throw new Error('Account Web root element is missing');

createRoot(root).render(<I18nProvider><AccountApplication config={config} runtime={runtime} /></I18nProvider>);
